const $doc = $(document);

function checkPasswordMatch() {
  const errorClass = 'form__row--error';
  const $errorMsg = $('.form__row--error-message');
  const $passwordRows = $('.form--register .form__row').has(
    'input[type="password"]'
  );
  let password = $('#field-password').val();
  let confirmPassword = $('#field-confirm-password').val();

  if (password != confirmPassword && password.length && confirmPassword.length) {
    $passwordRows.addClass(errorClass);

    $errorMsg.show();
  } else {
    $passwordRows.removeClass(errorClass);

    $errorMsg.hide();
  }
}

$doc.on('input', '.form--register input[type="password"]', () => checkPasswordMatch());